import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.f5w_1 = delegate;
        this.g5w_1 = call;
      }
      *q5e(frame, $completion) {
        yield* this.f5w_1.q5e(frame, $completion);
        return Unit_instance;
      }
      *a4n($completion) {
        yield* this.f5w_1.a4n($completion);
        return Unit_instance;
      }
      m5e(_set____db54di) {
        this.f5w_1.m5e(_set____db54di);
      }
      n5e() {
        return this.f5w_1.n5e();
      }
      o5e() {
        return this.f5w_1.o5e();
      }
      p5e() {
        return this.f5w_1.p5e();
      }
      ww() {
        return this.f5w_1.ww();
      }
      l5e(negotiatedExtensions) {
        this.f5w_1.l5e(negotiatedExtensions);
      }
      k5e() {
        return this.f5w_1.k5e();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.h5w_1 = session;
        this.i5w_1 = call;
      }
      *q5e(frame, $completion) {
        yield* this.h5w_1.q5e(frame, $completion);
        return Unit_instance;
      }
      *a4n($completion) {
        yield* this.h5w_1.a4n($completion);
        return Unit_instance;
      }
      m5e(_set____db54di) {
        this.h5w_1.m5e(_set____db54di);
      }
      n5e() {
        return this.h5w_1.n5e();
      }
      o5e() {
        return this.h5w_1.o5e();
      }
      p5e() {
        return this.h5w_1.p5e();
      }
      ww() {
        return this.h5w_1.ww();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
